import { useEffect, useState } from 'react'
import { bg } from 'lib/background'
import { debug } from 'lib/logging'

const requestingToggles = new Set<string>()
const toggles: Record<string, boolean> = {}
let requesting: Promise<void> | null = null

export async function getFeatureToggle(name: string | undefined): Promise<boolean> {
  if (name === undefined) {
    return true
  }

  debug(`toggles`, `getFeatureToggle`, name)
  if (toggles[name] !== undefined) {
    return toggles[name]
  }

  debug(`toggles`, `getFeatureToggle requesting`, name)
  requestingToggles.add(name)
  while (requestingToggles.has(name)) {
    debug(`toggles`, `getFeatureToggle waiting for`, name)
    await getThemToggles()
  }

  debug(`toggles`, `getThemToggles done`, name, `=`, toggles[name])
  return toggles[name] ?? false
}

const getThemToggles = async () => {
  if (requesting) {
    debug(`toggles`, `getThemToggles already requesting, next will be`, requestingToggles)
    return requesting
  }

  requesting = new Promise<void>(async (resolve) => {
    const nonce = Math.floor(Math.random() * 1_000_000).toString()
    let togglesToGet = Array.from(requestingToggles.values())
    debug(`toggles`, nonce, `getThemToggles start`, togglesToGet)
    togglesToGet = togglesToGet.filter((toggleName) => toggles[toggleName] === undefined)
    debug(`toggles`, nonce, `getThemToggles start2`, togglesToGet)

    if (togglesToGet.length === 0) {
      debug(`toggles`, nonce, `getThemToggles nothing to get`)
      requesting = null
      resolve()
      return
    }

    const url = `/api/feature-toggles/${togglesToGet.join(`,`)}`
    debug(`toggles`, nonce, `getThemToggles fetching`, url)
    const resp = await window.fetch(url)
    const data: Record<string, boolean> = await resp.json()
    debug(`toggles`, nonce, `getThemToggles got`, data)

    for (const [toggleName, value] of Object.entries(data)) {
      requestingToggles.delete(toggleName)
      toggles[toggleName] = value
    }

    requesting = null
    resolve()
  })

  return requesting
}

export function Feature(props: { name?: string; neg?: boolean; children: any }) {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    bg(async () => {
      let name = props.name
      let _enabled = await getFeatureToggle(name)
      debug(`toggles`, `Feature Component got toggle`, name, _enabled)
      setEnabled(_enabled)
    })
  }, [])

  const shouldRender = props.neg ? !enabled : enabled

  if (shouldRender) {
    return <>{props.children}</>
  } else {
    return <></>
  }
}
